import { Locale } from "@redotech/crdb-enums/common/locale";
import { TRANSLATION_SOURCES } from "@redotech/redo-customer-portal-common/translation-source";
import * as z from "zod";

export const PORTAL_CUSTOMIZATION_TRANSLATION_WRITE_LIMIT = 200;
export const PORTAL_CUSTOMIZATION_TRANSLATION_TEXT_LIMIT = 5000;

const KeySchema = z.object({
  elementId: z.uuid(),
  field: z.string().max(100),
  language: z.enum(Locale),
});

/** Canonical English stays on Team.portal.customization; a clear is a delete. */
export const setPortalCustomizationTranslations = {
  name: "setPortalCustomizationTranslations" as const,
  input: z.object({
    writes: z
      .array(
        KeySchema.extend({
          text: z
            .string()
            .min(1)
            .max(PORTAL_CUSTOMIZATION_TRANSLATION_TEXT_LIMIT),
          source: z.enum(TRANSLATION_SOURCES),
          sourceText: z
            .string()
            .max(PORTAL_CUSTOMIZATION_TRANSLATION_TEXT_LIMIT),
        }),
      )
      .max(PORTAL_CUSTOMIZATION_TRANSLATION_WRITE_LIMIT),
    deletes: z
      .array(KeySchema)
      .max(PORTAL_CUSTOMIZATION_TRANSLATION_WRITE_LIMIT),
  }),
  output: z.object({}),
};
